import React from 'react';
import { Wizard, Steps, Step } from 'react-albus';
import { HashRouter, Route } from 'react-router-dom';
import Age from './Steps/Age';
import HouseholdIncome from './Steps/HouseholdIncome';
import MonthlyExpenses from './Steps/MonthlyExpenses';
import MonthlySavings from './Steps/MonthlySavings';
import SavedSoFar from './Steps/SavedSoFar';
import Results from './Steps/Results';

const stepsMap = {
  Age,
  HouseholdIncome,
  MonthlyExpenses,
  MonthlySavings,
  SavedSoFar,
  Results,
};

interface Props {}

const ExpressWizard: React.FC<Props> = () => {
  return (
    <HashRouter basename="/step">
      <Route
        render={({ history }) => {
          return (
            <Wizard
              history={history}
              render={wizard => {
                return (
                  <Steps>
                    {Object.keys(stepsMap).map(stepId => {
                      const StepContent = stepsMap[stepId];

                      return (
                        <Step
                          id={stepId}
                          key={stepId}
                          render={() => <StepContent wizard={wizard} />}
                        />
                      );
                    })}
                  </Steps>
                );
              }}
            />
          );
        }}
      />
    </HashRouter>
  );
};

export default ExpressWizard;
